module.exports = __webpack_public_path__ + "img/patrick-boucher-0ccc00jMW1U-unsplash.4ecd8bc4.jpg";